export enum DraggableCommand {
    AddFirstChild = 'addFirstChild',
    Replace = 'replace',
    Remove = 'remove',
    Above = 'above',
    Below = 'below',
}
